import { IActionUrlForm } from '../types/ActionUrl';
// import { parserEmailTemplate } from './../utils/parserEmailTemplate';
import { useMutation } from 'react-query';
import { useHttpClient } from '../../../../shared/http/HttpClientProvider';
import { MutationOptions, MutationResult } from '../../../../shared/types/query';
import { PAGE_KEY } from './index';

export function useEditActionUrl(id?: string, options?: MutationOptions<IActionUrlForm, IActionUrlForm>): MutationResult<IActionUrlForm, IActionUrlForm> {
  const http = useHttpClient();

  return useMutation({
    ...options,
    mutationKey: [`${PAGE_KEY}/update`, id],
    mutationFn: async (obj: IActionUrlForm) => {
      return http.request({
        method: 'put',
        url: `ActionUrls/${id}`,
        data: obj,
      }).then(result => result.data)
    },
  })
}
